import React from 'react';
import PropTypes from 'prop-types';

import styles from './call_options.css';

import { CallBack } from './call_back/call_back';
import { CallUs } from './call_us/call_us';

const CallOptions = ({ stateProps, contentProps, visualProps = {} }) => {
    const { callBackToggle, callToggle } = stateProps;
    const { callBackLayout, callLayout } = contentProps;
    const { variant = 'root' } = visualProps;
    return (
        <div className={styles[variant]}>
            <CallBack isVisible={callBackToggle} layout={callBackLayout} stateProps={stateProps} />
            <CallUs isVisible={callToggle} layout={callLayout} stateProps={stateProps} />
        </div>
    );
};

CallOptions.propTypes = {
    stateProps: PropTypes.object.isRequired,
    contentProps: PropTypes.shape({
        callBackLayout: PropTypes.string.isRequired,
        callLayout: PropTypes.string.isRequired
    }),
    visualProps: PropTypes.object
};

export { CallOptions };
